import { PositionResolverOpts } from 'react-rainbow-components/components/InternalOverlay';

const positionResolver = (opts: PositionResolverOpts) => {
    const { trigger, content, viewport } = opts;
    const left = Math.min(
        trigger.leftUpAnchor.x,
        Math.max(14, viewport.width - content.width - 14),
    );

    return {
        top: Math.max(0, trigger.leftBottomAnchor.y + 8),
        left,
    };
};

export default positionResolver;
